// extracted by mini-css-extract-plugin
export default {"renameDialog":"zxfkdrs17tjHUIfzfQcL","input":"GiMoNbnRshc0oRwfUq0G"};